import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

function getCookie(cookieName) {
  const name = cookieName + '='
  const cDecoded = decodeURIComponent(document.cookie)
  const cArr = cDecoded.split('; ')
  let res
  cArr.forEach(val => {
    if (val.indexOf(name) === 0) res = val.substring(name.length)
  })
  return res
}

const languages = ['en', 'de']
let locale = process.env.default_language

if (window) {
  // set by subdomain
  const result = window.document.location.host.match(/^([A-Za-z]{2})\./)
  if (
    result &&
    result.length > 1 &&
    languages.includes(result[1])) {
    locale = result[1]
  }

  // set by cookie
  if (document) {
    const cookieLang = getCookie('i18n')
    if (languages.includes(cookieLang)) {
      locale = cookieLang
    }
  }
}

const messages = {}
for (const lang of languages) {
  messages[lang] = require(`../locales/${lang}.json`)
}

const i18n = new VueI18n({
  locale,
  messages
})

export default i18n



// WEBPACK FOOTER //
// ./src/config/i18n.js